<template>
  <div>
    <div v-if="hasPower">
      <slot></slot>
    </div>
    <div v-else>抱歉，你没有权限访问</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { judgePower } from '@/utils/utils'

export default {
  name: 'PowerWrapper',
  props: {
    CurrRole: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters([
      'roles'
    ]),
    hasPower () {
      return judgePower(this.roles, this.CurrRole)
    }
  }
}
</script>

<style scoped>

</style>
